import type { PetitionDraft } from '#src/app/shared/api/petitionDraft';

import type { JobDoneEvent } from '../operations/types';

import type { ControlActors, ControlChildren } from './control/types';

export type Draft = Partial<PetitionDraft>;

export const MediaTypes = { AI: 'AI_GENERATED', USER: 'USER_UPLOADED' } as const;

/** A variant actor owns the draft; it is the only place the draft is written. */
export type VariantContext = { draft?: Draft | null };

/** A variant boots with its context as input. */
export type VariantInput = VariantContext;

/**
 * The events a step component sends. `submit` and `back` are what every step implements; `patch`
 * merges a draft change without navigating and is handled at the variant's root.
 */
export type StepEvents =
	| { type: 'back'; target?: null }
	| { type: 'submit'; draft?: Draft; target?: string | null }
	| { type: 'error' }
	| { type: 'patch'; draft: Draft };

/** Everything a variant actor receives: its steps' events, plus background operation results. */
export type VariantEvents = StepEvents | JobDoneEvent;

// One member per variant. Adding a variant is a folder plus one entry in each intersection below.

/** What the orchestrator provides to host every variant in its flow region. */
export type FlowChildren = ControlChildren;
export type FlowActors = ControlActors;
